import MobileDetect from 'mobile-detect';
import {has} from "lodash";

const isDevRelaxed = process.env.NODE_ENV === 'development';

const checkPWAInstalled = (): boolean => {
    if (typeof window === 'undefined') return false;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isIOSStandalone = (navigator as any).standalone === true;
    return isStandalone || isIOSStandalone;
};

const isActuallyMobile = (): boolean => {
    if (isDevRelaxed || has(window, "Kiosk")) return false;
    if (typeof window === 'undefined') return false;

    const md = new MobileDetect(window.navigator.userAgent);
    const isModernUA = (navigator as any).userAgentData?.mobile ?? false;

    return isModernUA || !!md.mobile();
};

const isIphone = (): boolean => {
    if (typeof window === 'undefined') return false;
    const md = new MobileDetect(window.navigator.userAgent);
    return md.os() === 'iOS' && md.phone() === 'iPhone';
};

const pwaStatus = () => {
    return {
        isInstalled: checkPWAInstalled(),
        isMobile: isActuallyMobile(),
        isIphone: isIphone(),
    };
};

export default pwaStatus;
